export default {
    name: {
      title: {
        matches: ({ value, get }) => {
          return true;
        }
      }
    }
  };
